import { render } from "./completion-reporting.vue?vue&type=template&id=48dde568&scoped=true"
import script from "./completion-reporting.vue?vue&type=script&lang=js"
export * from "./completion-reporting.vue?vue&type=script&lang=js"

import "./completion-reporting.vue?vue&type=style&index=0&id=48dde568&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dde568"]])

export default __exports__